import Vue from 'vue';
import Vuex from 'vuex';

import { LoadingModule } from '@/types/modules/LoadingModule';

Vue.use(Vuex);

export interface RootState {
  loading: LoadingModule;
}

export default new Vuex.Store<RootState>({
  strict: process.env.NODE_ENV !== 'production'
});
